import { useState } from "react";
import type { ReplyTemplate } from "../types";
import ConfirmRemove from "./ConfirmRemove";

type Props = {
  templates: ReplyTemplate[];
  busy: boolean;
  onSave: (tpl: { id?: string; name: string; text: string }) => Promise<void>;
  onDelete: (id: string) => void;
};

export default function ReplyTemplates({ templates, busy, onSave, onDelete }: Props) {
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [editId, setEditId] = useState("");
  const [editName, setEditName] = useState("");
  const [editText, setEditText] = useState("");

  return (
    <section className="pr-card p-6">
      <h3 className="text-lg font-semibold">Modèles</h3>
      <p className="mt-1 text-sm text-slate-500">Cinq réponses, à nommer et réutiliser.</p>
      <ul className="mt-5 space-y-3">
        {templates.map((tpl) => (
          <li key={tpl.id} className="rounded-2xl bg-mist px-4 py-3">
            {editId === tpl.id ? (
              <form
                className="space-y-2"
                onSubmit={(e) => {
                  e.preventDefault();
                  void onSave({ id: tpl.id, name: editName, text: editText }).then(() => setEditId(""));
                }}
              >
                <input value={editName} onChange={(e) => setEditName(e.target.value)} className="pr-input" />
                <textarea rows={3} value={editText} onChange={(e) => setEditText(e.target.value)} className="pr-area" />
                <div className="flex gap-2">
                  <button type="submit" disabled={busy} className="pr-btn">
                    Enregistrer
                  </button>
                  <button type="button" className="pr-btn-ghost" onClick={() => setEditId("")}>
                    Annuler
                  </button>
                </div>
              </form>
            ) : (
              <div>
                <p className="text-sm font-semibold">{tpl.name}</p>
                <p className="mt-1 text-sm leading-6 text-slate-600">{tpl.text}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <button
                    type="button"
                    className="pr-btn-ghost"
                    onClick={() => {
                      setEditId(tpl.id);
                      setEditName(tpl.name);
                      setEditText(tpl.text);
                    }}
                  >
                    Modifier
                  </button>
                  <ConfirmRemove question="Retirer ce modèle ?" onConfirm={() => onDelete(tpl.id)} />
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
      {templates.length < 5 ? (
        <form
          className="mt-5 space-y-2"
          onSubmit={(e) => {
            e.preventDefault();
            void onSave({ name, text }).then(() => {
              setName("");
              setText("");
            });
          }}
        >
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nom" className="pr-input" />
          <textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="Texte de la réponse" className="pr-area" />
          <button type="submit" disabled={busy} className="pr-btn">
            {busy ? "Enregistrement…" : `Ajouter (${templates.length}/5)`}
          </button>
        </form>
      ) : (
        <p className="mt-4 text-xs text-slate-500">Cinq modèles. Retirez-en un pour en créer un autre.</p>
      )}
    </section>
  );
}
